import { connect } from 'react-redux';
import ToastComponent from '../../components/Toast/ToastComponent';
import { Global } from '../../state/Global';
import { networkSelectors } from '@lifesize/nucleus';

const mapStateToProps = (state: Global) => {
  const isOffline = networkSelectors.isOffline(state);
  const isWampConnected = networkSelectors.isWampConnected(state);

  return {
    hasNetworkIssue: isOffline || !isWampConnected
  };
};

export const ToastContainer = connect(mapStateToProps, null)(ToastComponent);
